// Passkey (WebAuthn), fatia 2 — LOGIN a partir da tela de entrada. Discoverable/usernameless:
// pede opções sem allowCredentials, o autenticador escolhe a passkey e o servidor resolve o dono.
// Progressive enhancement: sem WebAuthn, o botão some (o login por senha continua). Same-origin,
// então a CSP (script_src :self) não muda.

function base64urlToBuffer (value) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4)
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/')
  const binary = window.atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i)
  return bytes.buffer
}

function bufferToBase64url (buffer) {
  if (!buffer) return null
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i])
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export default class PasskeyLoginButton extends HTMLElement {
  connectedCallback () {
    this.button = this.querySelector('button') || this.querySelector('[data-passkey-trigger]')
    this.errorEl = this.querySelector('[data-passkey-error]')

    // Sem WebAuthn: esconde o bloco inteiro; a tela segue com o login por senha.
    if (!window.PublicKeyCredential) {
      this.classList.add('hidden')
      return
    }

    if (this.button) {
      this.button.addEventListener('click', (event) => {
        event.preventDefault()
        this.login()
      })
    }
  }

  async login () {
    this.clearError()
    if (this.button) this.button.disabled = true

    try {
      const options = await this.fetchOptions()
      options.challenge = base64urlToBuffer(options.challenge)
      if (Array.isArray(options.allowCredentials)) {
        options.allowCredentials = options.allowCredentials.map((cred) => ({
          ...cred,
          id: base64urlToBuffer(cred.id)
        }))
      }

      const assertion = await navigator.credentials.get({ publicKey: options })
      const result = await this.postAssertion(assertion)

      if (result && result.redirect_url) {
        window.location.href = result.redirect_url
      } else {
        window.location.reload()
      }
    } catch (error) {
      if (this.button) this.button.disabled = false
      // Cancelamento pelo usuário: não é falha para alarmar.
      if (error && error.name === 'NotAllowedError') return

      this.showError()
    }
  }

  async fetchOptions () {
    const response = await fetch(this.dataset.optionsUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
    if (!response.ok) throw new Error('options request failed')
    return response.json()
  }

  async postAssertion (assertion) {
    const payload = {
      credential: {
        id: assertion.id,
        type: assertion.type,
        rawId: bufferToBase64url(assertion.rawId),
        authenticatorAttachment: assertion.authenticatorAttachment,
        clientExtensionResults: assertion.getClientExtensionResults(),
        response: {
          authenticatorData: bufferToBase64url(assertion.response.authenticatorData),
          clientDataJSON: bufferToBase64url(assertion.response.clientDataJSON),
          signature: bufferToBase64url(assertion.response.signature),
          userHandle: bufferToBase64url(assertion.response.userHandle)
        }
      }
    }

    const response = await fetch(this.dataset.loginUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken()
      },
      body: JSON.stringify(payload)
    })

    if (!response.ok) throw new Error('login rejected')
    return response.json()
  }

  csrfToken () {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }

  clearError () {
    if (this.errorEl) this.errorEl.classList.add('hidden')
  }

  showError () {
    if (this.errorEl) this.errorEl.classList.remove('hidden')
  }
}
